import { NUMBER_2 } from "~shared/constants"

export const akamaiImageSrcset = ({
  src,
  width,
  policy
}: {
  src: string
  width: number
  policy: string
}) => {
  return `${src}?impolicy=${policy}&imwidth=${width} 1x, ${src}?impolicy=${policy}&imwidth=${width * NUMBER_2} 2x`
}
